// import React, { useEffect, useRef, useState } from 'react';
// import { HiX } from "react-icons/hi";
// import { NavLink } from "react-router-dom";
// import routes from "../../routes";
// import logo from "../../assets/img/logos/HcLogo-black.png";
// import './Sidebar.css';

// const Sidebar = ({ open, onClose }) => {
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const sidebarRef =useRef(null);
//   const toggleDropdown = (name) => {
//     setOpenDropdown((prev) => (prev === name ? null : name));
//   };

//    useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         open &&
//         sidebarRef.current &&
//         !sidebarRef.current.contains(event.target) &&
//         window.innerWidth < 1280
//       ) {
//         onClose();
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [open, onClose]);

//   // Filter routes to show only those that should appear in the sidebar
//   const filteredRoutes = routes.filter(route => route.showInSidebar);

//   return (
//     <div
//      ref={sidebarRef}
//       className={`fixed left-0 top-0 z-50 h-full w-72 transform rounded-r-3xl bg-[#ffffff] p-4 font-medium tracking-wide text-gray-900 shadow-lg transition-transform ${
//         open ? "translate-x-0" : "-translate-x-full"
//       } xl:translate-x-0`}
//     >
//       <div className="flex items-center justify-between gap-4 rounded-full bg-[#ffffff] p-4">
//         <div>
//           <img src={logo} alt="logo" />
//         </div>
//         <button
//           className="text-gray-300 hover:text-white focus:outline-none xl:hidden"
//           onClick={onClose}
//         >
//           <HiX className="h-6 w-6 text-navy-700" />
//         </button>
//       </div>

//       <div className="mt-4 border-b border-[#c51369]" />

//       <nav className="hide-scrollbar mt-4 flex h-[calc(100%-120px)] flex-col space-y-2 overflow-y-auto">
//         {filteredRoutes.map(
//           (route, index) =>
//             route.path !== "sign-in" && (
//               <div key={index} className="w-full">
//                 {!route.children ? (
//                   <NavLink
//                     to={`${route.layout}/${route.path}`}
//                     className={({ isActive }) =>
//                       `flex items-center rounded-full px-6 py-2 transition-all duration-200 ${
//                         isActive
//                           ? "bg-[#c51369] text-white"
//                           : "text-[#c51369] hover:bg-[#f54ea2] hover:text-white"
//                       }`
//                     }
//                   >
//                     {route.icon}
//                     <span className="ml-3">{route.name}</span>
//                   </NavLink>
//                 ) : (
//                   <div>
//                     <button
//                       onClick={() => toggleDropdown(route.name)}
//                       className="flex w-full items-center justify-between rounded-full bg-[#ffffff] px-6 py-2 text-[#c51369] transition-all duration-200 hover:bg-[#f54ea2] hover:text-white focus:outline-none"
//                     >
//                       <div className="flex items-center">
//                         {route.icon}
//                         <span className="ml-3">{route.name}</span>
//                       </div>
//                       <svg
//                         className={`h-4 w-4 transform transition-transform ${
//                           openDropdown === route.name ? "rotate-180" : ""
//                         }`}
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth="2"
//                           d="M19 9l-7 7-7-7"
//                         ></path>
//                       </svg>
//                     </button>

//                     <div
//                       className={`ml-6 mt-2 overflow-hidden transition-[max-height] duration-500 ease-in-out ${
//                         openDropdown === route.name
//                           ? "max-h-96 opacity-100"
//                           : "max-h-0 opacity-0"
//                       }`}
//                     >
//                       {route.children.map((child, childIndex) => (
//                         <NavLink
//                           key={childIndex}
//                           to={`${child.layout}/${child.path}`}
//                           className={({ isActive }) =>
//                             `mb-2 flex items-center rounded-full px-6 py-2 transition-all duration-200 ${
//                               isActive
//                                 ? "bg-[#c51369] text-white"
//                                 : "text-[#c51369] hover:bg-[#f54ea2] hover:text-white"
//                             }`
//                           }
//                         >
//                           <span className="ml-3">{child.name}</span>
//                         </NavLink>
//                       ))}
//                     </div>

//                   </div>
//                 )}
//               </div>
//             )
//         )}
//       </nav>

//       <div className="flex-grow" />

//       <div className="p-4">
//         {/* Add any footer or additional content here */}
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

// import { HiX } from "react-icons/hi";
// import routes from "../../routes";
// import { NavLink } from "react-router-dom";
// import { useState } from "react";
// import logo from "../../assets/img/logos/HcLogo-black.png";
// import './Sidebar.css';

// const Sidebar = ({ open, onClose }) => {
//   const [openDropdown, setOpenDropdown] = useState(null);

//   const toggleDropdown = (name) => {
//     setOpenDropdown((prev) => (prev === name ? null : name));
//   };

//   return (
//     <div
//       className={`fixed rounded-r-3xl top-0 left-0 tracking-wide font-medium z-50 h-full w-72 bg-[#ffffff] p-4 text-gray-900 shadow-lg transition-transform transform ${
//         open ? "translate-x-0" : "-translate-x-full"
//       } md:translate-x-0`}
//     >
//       <div className="flex items-center justify-between p-4 bg-[#ffffff] rounded-full">
//         <div>
//           <img src={logo} alt="logo" />
//         </div>
//         <button
//           className="text-gray-300 hover:text-white focus:outline-none md:hidden"
//           onClick={onClose}
//         >
//           <HiX className="w-6 h-6" color="blue" />
//         </button>
//       </div>

//       <div className="mt-4 border-b border-[#c51369]" />

//       <nav className="mt-4 flex flex-col space-y-2 overflow-y-auto h-[calc(100%-120px)] hide-scrollbar">
//         {routes.map(
//           (route, index) =>
//             route.path !== "sign-in" && (
//               <div key={index} className="w-full">
//                 {!route.children ? (
//                   <NavLink
//                     to={`${route.layout}/${route.path}`}
//                     className={({ isActive }) =>
//                       `flex items-center py-2 px-6 rounded-full transition-all duration-200 ${
//                         isActive
//                           ? "bg-[#c51369] text-white"
//                           : "hover:bg-[#f54ea2] text-[#c51369] hover:text-white"
//                       }`
//                     }
//                   >
//                     {route.icon}
//                     <span className="ml-3">{route.name}</span>
//                   </NavLink>
//                 ) : (
//                   <div>
//                     <button
//                       onClick={() => toggleDropdown(route.name)}
//                       className="flex items-center justify-between w-full py-2 px-6 text-[#c51369] rounded-full transition-all duration-200 bg-[#ffffff] hover:bg-[#f54ea2] hover:text-white focus:outline-none"
//                     >
//                       <div className="flex items-center">
//                         {route.icon}
//                         <span className="ml-3">{route.name}</span>
//                       </div>
//                       <svg
//                         className={`w-4 h-4 transition-transform transform ${
//                           openDropdown === route.name ? "rotate-180" : ""
//                         }`}
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                         xmlns="http://www.w3.org/2000/svg"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth="2"
//                           d="M19 9l-7 7-7-7"
//                         ></path>
//                       </svg>
//                     </button>
//                     <div
//                       className="ml-6 mt-2 overflow-hidden"
//                       style={{
//                         maxHeight: openDropdown === route.name ? "200px" : "0",
//                         transition: "max-height 0.5s ease"
//                       }}
//                     >
//                       {route.children.map((child, childIndex) => (
//                         <NavLink
//                           key={childIndex}
//                           to={`${child.layout}/${child.path}`}
//                           className={({ isActive }) =>
//                             `flex items-center py-2 px-6 rounded-full transition-all duration-200 mb-2 ${
//                               isActive
//                                 ? "bg-[#c51369] text-white "
//                                 : "hover:bg-[#f54ea2] text-[#c51369] hover:text-white"
//                             }`
//                           }
//                         >
//                           <span className="ml-3">{child.name}</span>
//                         </NavLink>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )
//         )}
//       </nav>

//       <div className="flex-grow" />

//       <div className="p-4">
//         {/* Add any footer or additional content here */}
//       </div>
//     </div>
//   );
// };

// export default Sidebar;
// Sidebar.js  (UPDATED PERMISSION LOGIC — REST KEPT SAME)

import React, { useEffect, useRef, useState } from "react";
import { HiX } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import routes from "../../routes";
import logo from "../../assets/img/logos/HcLogo-black.png";
import "./Sidebar.css";
import { usePermission } from "Context/PermissionContext";

const Sidebar = ({ open, onClose }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const sidebarRef = useRef(null);
  const { permissions } = usePermission();

  const toggleDropdown = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        open &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        window.innerWidth < 1280
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, onClose]);

  // -------------------------------------------------------
  // 🔥 PERMISSION HELPERS (UPDATED TO SUPPORT NESTED SUBMODULES)
  // -------------------------------------------------------

  const getPermissionNode = (permissionKey) => {
    if (!permissionKey) return null;

    // For example: "users.user" → permissions.users.subModule.user
    const parts = permissionKey.split(".");
    let node = permissions;

    for (let p of parts) {
      if (!node) return null;

      // If parent & has submodules
      if (node.subModule && node.subModule[p]) {
        node = node.subModule[p];
      }
      // Normal direct permission (dashboard, appFeedback etc.)
      else {
        node = node[p];
      }
    }

    return node;
  };

  // Check if parent menu should show
  const canView = (permissionKey) => {
    // No permissionKey defined = always visible (e.g. Events)
    if (!permissionKey) return true;

    const node = getPermissionNode(permissionKey);
    if (!node) return false;

    // Direct view
    if (node.permissions?.view) return true;

    // Any child has view permission?
    if (node.subModule) {
      return Object.values(node.subModule).some(
        (child) => child.permissions?.view
      );
    }

    return false;
  };

  // Check if child menu should show
  const canViewChild = (permissionKey) => {
    const node = getPermissionNode(permissionKey);
    return node?.permissions?.view === true;
  };

  const filteredRoutes = routes.filter((route) => route.showInSidebar);

  return (
    <div
      ref={sidebarRef}
      className={`fixed left-0 top-0 z-50 h-full w-72 transform rounded-r-3xl bg-[#ffffff] p-4 font-medium tracking-wide text-gray-900 shadow-lg transition-transform ${
        open ? "translate-x-0" : "-translate-x-full"
      } xl:translate-x-0`}
    >
      {/* Logo */}
      <div className="flex items-center justify-between gap-4 rounded-full bg-[#ffffff] p-4">
        <div>
          <img src={logo} alt="logo" />
        </div>
        <button
          className="text-gray-300 hover:text-white focus:outline-none xl:hidden"
          onClick={onClose}
        >
          <HiX className="h-6 w-6 text-navy-700" />
        </button>
      </div>

      <div className="mt-4 border-b border-[#c51369]" />

      {/* NAVIGATION */}
      <nav className="hide-scrollbar mt-4 flex h-[calc(100%-120px)] flex-col space-y-2 overflow-y-auto">
        {filteredRoutes.map((route, index) => {
          if (route.path === "sign-in") return null;

          if (!canView(route.permissionKey)) return null;

          return (
            <div key={index} className="w-full">
              {/* --- PARENT WITHOUT CHILDREN --- */}
              {!route.children ? (
                <NavLink
                  to={`${route.layout}/${route.path}`}
                  className={({ isActive }) =>
                    `flex items-center rounded-full px-6 py-2 transition-all duration-200 ${
                      isActive
                        ? "bg-[#c51369] text-white"
                        : "text-[#c51369] hover:bg-[#f54ea2] hover:text-white"
                    }`
                  }
                >
                  {route.icon}
                  <span className="ml-3">{route.name}</span>
                </NavLink>
              ) : (
                <>
                  {/* Parent Dropdown */}
                  <button
                    onClick={() => toggleDropdown(route.name)}
                    className="flex w-full items-center justify-between rounded-full bg-[#ffffff] px-6 py-2 text-[#c51369] transition-all duration-200 hover:bg-[#f54ea2] hover:text-white"
                  >
                    <div className="flex items-center">
                      {route.icon}
                      <span className="ml-3">{route.name}</span>
                    </div>

                    <svg
                      className={`h-4 w-4 transform transition-transform ${
                        openDropdown === route.name ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {/* Child List */}
                  <div
                    className={`ml-6 mt-2 overflow-hidden transition-[max-height] duration-500 ease-in-out ${
                      openDropdown === route.name
                        ? "max-h-96 opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    {route.children
                      .filter((child) => canViewChild(child.permissionKey))
                      .map((child, idx) => (
                        <NavLink
                          key={idx}
                          to={`${child.layout}/${child.path}`}
                          className={({ isActive }) =>
                            `mb-2 flex items-center rounded-full px-6 py-2 transition-all duration-200 ${
                              isActive
                                ? "bg-[#c51369] text-white"
                                : "text-[#c51369] hover:bg-[#f54ea2] hover:text-white"
                            }`
                          }
                        >
                          <span className="ml-3">{child.name}</span>
                        </NavLink>
                      ))}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </nav>

      <div className="flex-grow" />

      <div className="p-4">{/* footer */}</div>
    </div>
  );
};

export default Sidebar;
